var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"err-hide text-center",class:{'err-show':_vm.error!==''},attrs:{"id":"Error"}},[_c('p',{staticClass:"rounded white bg-red-6"},[_vm._v(_vm._s(_vm.error))])])}
var staticRenderFns = []

export { render, staticRenderFns }